import { render, staticRenderFns } from "./AccountActivationPage.vue?vue&type=template&id=5d68192c&"
import script from "./AccountActivationPage.vue?vue&type=script&lang=js&"
export * from "./AccountActivationPage.vue?vue&type=script&lang=js&"
import style0 from "./AccountActivationPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports